import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AdminService } from '../services/admin.service';
import { Observable, from, map } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AdminGuard implements CanActivate {
    constructor(
        private authService: AuthService,
        private adminService: AdminService,
        private router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        // First do a quick sync check
        if (!this.authService.isAuthenticated() || !this.adminService.isAdmin()) {
            this.router.navigate(['/']);
            return false;
        }

        // Then verify with Supabase
        return from(this.authService.isAuthenticatedAsync()).pipe(
            map(isAuth => {
                if (isAuth && this.adminService.isAdmin()) {
                    return true;
                } else {
                    this.router.navigate(['/']);
                    return false;
                }
            })
        );
    }
}